module.exports = "/* **For the font-size of the label name of the Additional Color option** */\r\n#exp-tab-name{\r\n    margin-top: 56px;\r\n}\r\n\r\n\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/selectable-tabs/expert-screen-components/expert-additional-color/expert-additional-color.component.css
// module id = ./src/app/components/selectable-tabs/expert-screen-components/expert-additional-color/expert-additional-color.component.css
// module chunks = main